document.addEventListener('DOMContentLoaded', async function () {
  const url = new URL(window.location.href);
  const ref = url.searchParams.get('ref');

  if (ref) {
    document.cookie = `ref_id=${ref}; path=/; max-age=${60 * 60 * 24 * 30}`;
    console.log('Referral ID saved in cookie:', ref);
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  const referralId = getCookie('ref_id');

  if (referralId) {
    try {
      await fetch('/apps/referral/set-referrer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ referral_id: referralId })
      });

      document.cookie = "ref_id=; Max-Age=0; path=/;";
      console.log('Referral sent:', referralId);
    } catch (err) {
      console.error('Error sending referral:', err);
    }
  }
});
